import React, { Component } from "react";
import { FormControl, Modal, Table } from "react-bootstrap";
import { isValidArray } from "../../../../helper";

class UserInfo extends Component {
  constructor(props) {
    super(props);
    const { options } = props;
    this.state = {
      list: options || []
    };
  }

  onSearch = e => {
    const { value } = e.target;
    this.setState({
      search: value
    });
  };

  getSeachedData = () => {
    const { search, list } = this.state;
    const regex = RegExp(search, "ig");
    return (
      isValidArray(list) &&
      list.filter(value => {
        return Object.values(value).find(text => regex.test(text));
      })
    );
  };

  render() {
    const { onSearch, getSeachedData } = this;
    const { onCloseModal, titles } = this.props;
    const searchedData = getSeachedData();
    return (
      <Modal
        show={true}
        size="sm"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        dialogClassName="send_notification_modal_user_info"
        onHide={onCloseModal}
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            User Info
          </Modal.Title>
        </Modal.Header>
        <br />
        <Modal.Body>
          <div className="messageTemplate user-info">
            <FormControl
              placeholder="Search"
              aria-label="Username"
              aria-describedby="basic-addon1"
              onChange={onSearch}
            />
            <br />
            <Table striped bordered hover size="sm">
              <thead>
                <tr>
                  {isValidArray(titles)
                    ? titles.map(value => {
                        return <th>{value}</th>;
                      })
                    : null}
                </tr>
              </thead>
              <tbody
                className={isValidArray(searchedData) ? "" : "data-not-found"}
              >
                {isValidArray(searchedData) ? (
                  searchedData.map(value => (
                    <tr>
                      <td>{value.name}</td>
                      <td>{value.emailMobile}</td>
                    </tr>
                  ))
                ) : (
                  <span>No data found!</span>
                )}
              </tbody>
            </Table>
          </div>
        </Modal.Body>
      </Modal>
    );
  }
}

export { UserInfo };
